import * as tslib_1 from "tslib";
export function buildQuery(params) {
    var e_1, _a;
    var searchParams = new URLSearchParams();
    try {
        for (var _b = tslib_1.__values(Object.entries(params)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = tslib_1.__read(_c.value, 2), key = _d[0], value = _d[1];
            value && searchParams.set(key, "" + value);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return searchParams.toString();
}
/**
 * Builds query string from an object
 * Returns an empty string if no passed `params`
 * @example
 * ```
 * toQueryParams({ limit: 2, cursor_token: 4 })
 * // '?limit=2&cursor_token=4'
 *
 * toQueryParams({})
 * // ''
 * ```
 * @return {string}
 * @param params
 */
export function toQueryParams(params) {
    if (params === void 0) { params = {}; }
    var q = buildQuery(params);
    return q && "?" + q;
}
//# sourceMappingURL=urlUtils.js.map